var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7648 0C13.8649 0 14.9232 0.441667 15.7017 1.23417C16.481 2.025 16.9167 3.09167 16.9167 4.20833V10.7917C16.9167 13.1167 15.0544 15 12.7648 15H4.66034C2.37069 15 0.509277 13.1167 0.509277 10.7917V4.20833C0.509277 1.88333 2.36249 0 4.66034 0H12.7648ZM14.0697 5.44962L14.1353 5.38296C14.3314 5.14129 14.3314 4.79129 14.1263 4.54962C14.0123 4.42546 13.8556 4.34962 13.6923 4.33296C13.5201 4.32379 13.356 4.38296 13.2321 4.49962L9.53308 7.49962C9.05726 7.90046 8.37554 7.90046 7.89234 7.49962L4.20068 4.49962C3.94554 4.30796 3.59279 4.33296 3.38031 4.55796C3.15881 4.78296 3.1342 5.14129 3.32206 5.39129L3.42953 5.49962L7.16221 8.45796C7.62162 8.82462 8.17865 9.02462 8.76193 9.02462C9.34357 9.02462 9.91045 8.82462 10.369 8.45796L14.0697 5.44962Z",
    fill: "#030229"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.4d04bb5b35394abc7696d66a9af4b7b5.svg";
export { ForwardRef as ReactComponent };